import React from "react"
import ProductFolioItemPresenterGeneral from "./tabs/ProductFolioItemPresenterGeneral"
import ProductFolioItemPresenterNotes from "./tabs/ProductFolioItemPresenterNotes"
import ProductFolioItemPresenterHistory from "./tabs/ProductFolioItemPresenterHistory"
import ProductFolioItemPresenterServiceRequests from "./tabs/ProductFolioItemPresenterServiceRequests"

class ProductFolioItemPresenterTabContent extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return(
      <div className="tab-content">
        <ProductFolioItemPresenterGeneral {...this.props} />
        {
          !this.props.edit_booking
            ?
          <ProductFolioItemPresenterNotes {...this.props} />
            :
          null
        }
        {this.props.read_only ? <ProductFolioItemPresenterHistory {...this.props} /> : null}

      </div>
    )
  }
}

export default ProductFolioItemPresenterTabContent
